module.exports = __webpack_public_path__ + "img/paws.18e9168e.png";